import { CountUp } from 'countup.js';

export default class NumberAnimation {

	/**
	 * Initializes number counter module using inView and CountUp libraries
	 * Number counter wrapper must have assigned class "number-counter"
	 * Numbers must contain attribute "data-number-counter", value of "data-number"-attribute of this element will be used
	 * as target number
	 */
	static init() {
		return new NumberAnimation();
	}

	constructor() {
		this.animateNumbers();
	}

	animateNumbers() {
		const numbers = document.querySelectorAll('.number-counter *[data-number-counter]');
	
		if (numbers.length === 0)
			return;
		
		numbers.forEach((number) => {
			let value = parseFloat(number.dataset.numberCounter);
			if (isNaN(value)) {
				value = 0.0;
			}
			const numAnim = new CountUp(number.id, value, {
				separator: '.',
				decimal: ',',
				enableScrollSpy: true,
				decimalPlaces: (value % 1 != 0) ? 2 : 0
			});
	
			if (!numAnim.error) numAnim.start();
			else throw new Error(numAnim.error);
		});
	}
}